import { Injectable } from '@angular/core';
import { Observable, of, ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { User } from 'app/core/Models/user';
import { Roles } from '../Enums/Roles';
import { AccountClient, ChangePassword } from 'Nswag/nswag-api-auth';
// import { StaffClient } from 'Nswag/nswag-api-staff';

@Injectable({ providedIn: 'root' })
export class UserService {
    private _user: ReplaySubject<User> = new ReplaySubject<User>(1);
    private _userValue: User;
    private _isCurrentUserDataDownloaded: boolean = false;

    constructor(
        private accountClient: AccountClient
    ) // private staffClient: StaffClient
    {
        this._user.subscribe(u => {
            this._userValue = u;
        });
    }

    set user(value: User) {
        this._user.next(value);
    }

    get user(): User {
        return this._userValue
    }

    get user$(): Observable<User> {
        return this._user.asObservable();
    }

    isUser = (role: Roles): boolean =>
        !!this._userValue?.roles.find(f => f == role);

    isMainRole = (role: Roles): boolean => this._userValue?.mainRole == role;

    get currentUser$(): Observable<User> {
        return this._isCurrentUserDataDownloaded
            ? this._user.asObservable()
            : this.get();
    }

    get(): Observable<User> {
        return this.accountClient.getUserProfile().pipe(
            map(userProfile => {
                this._isCurrentUserDataDownloaded = true;
                let user = Object.assign(new User(), userProfile);
                user.status = 'online';
                this.user = user;
                // this.setUserImage(user);
                return user;
            })
        );
    }

    /**
     * Possible To Update User In Back-end
     */
    update(user: User): Observable<any> {
        return of('');
    }

    changeUserPassword(changeUserPasswordModel: ChangePassword): Observable<boolean> {
        return this.accountClient.changeUserPassword(changeUserPasswordModel).pipe(
            map((response) =>{
                if(response.message === 'Ok') return true;
                else return false;
            })
        );
    }

    // setUserImage(user: User) {
    //     this.getUserImage(user).subscribe((base64string) => {
    //         user.tbFileImageBase64 = user.avatar = base64string;
    //         user.status = 'online';
    //         this.user = user;
    //     });
    // }

    // getUserImage(user: User): Observable<string> {
    //     return this.staffClient.staffImageByStaffIdInBase64(+user.tbStaffId);
    // }
}
